import ShareView from '@/views/share/ShareView.vue';
import ShareSubView from '@/views/share/ShareSubView.vue';

export default [
    {
        path: '/share',
        name: 'share',
        component: ShareView,
        meta: {
            title: 'share',
            hideInMenu: true,
        },
        children: [
            /** 旧路径兼容 + 重定向 后续需删除 start  */
            {
                path: 'channel/:shareId',
                name: 'shareLinkChannelAnalysisOld',
                meta: {
                    title: 'shareLinkChannelAnalysis',
                    hideInMenu: true,
                },
                redirect: (to: any) => {
                    return {
                        name: 'shareLinkChannelAnalysis',
                        params: { shareId: to.params.shareId },
                    };
                },
            },
            {
                path: 'verify/:id',
                name: 'shareVerifyOld',
                meta: {
                    title: 'shareVerify',
                    hideInMenu: true,
                },
                redirect: (to: any) => {
                    return {
                        name: 'shareVerifyChannel',
                        params: { id: to.params.id },
                    };
                },
            },
            /** 旧路径兼容 + 重定向 后续需删除 end  */

            /** 分享链接-报告 start */
            {
                path: 'analysis',
                name: 'shareAnalysis',
                component: ShareSubView,
                meta: {
                    title: 'shareAnalysis',
                    hideInMenu: true,
                },
                redirect: (to: any) => {
                    return {
                        name: 'shareVerifyChannel',
                        params: { id: to.params.id },
                    };
                },
                children: [
                    /** 分享链接验证 start */
                    {
                        path: 'verify/channel/:id',
                        name: 'shareVerifyChannel',
                        component: () => import(/* webpackChunkName: "share" */ '@/views/share/ShareVerify.vue'),
                        meta: {
                            title: 'shareVerify',
                            hideInMenu: true,
                        },
                        props: () => {
                            return {
                                type: '0',
                            };
                        },
                    },
                    {
                        path: 'verify/customer/:id',
                        name: 'shareVerifyCustomer',
                        component: () => import(/* webpackChunkName: "share" */ '@/views/share/ShareVerify.vue'),
                        meta: {
                            title: 'shareVerify',
                            hideInMenu: true,
                        },
                        props: () => {
                            return {
                                type: '1',
                            };
                        },
                    },
                    /** 分享链接验证 end */
                    /** 渠道分析 start */
                    {
                        path: 'channel/:shareId',
                        name: 'shareLinkChannelAnalysis',
                        component: () => import(/* webpackChunkName: "share" */ '@/views/share/ShareChannel.vue'),
                        meta: {
                            title: 'shareLinkChannelAnalysis',
                            hideInMenu: true,
                        },
                    },
                    /** 渠道分析 end */

                    /** 客户分析 start */
                    {
                        path: 'customer/:shareId',
                        name: 'shareLinkCustomerAnalysis',
                        component: () => import(/* webpackChunkName: "share" */ '@/views/share/ShareCustomer.vue'),
                        meta: {
                            title: 'shareLinkCustomerAnalysis',
                            hideInMenu: true,
                        },
                    },
                    /** 客户分析 end */
                ],
            },
            /** 分享链接-报告 end */
        ],
    },

];
